/**
 * Shared query string utility.
 * Extracted from paymentService.ts and duesService.ts which had identical copies.
 */

/** Build a URL query string from a params object, filtering out null/undefined values.
 *  Arrays are expanded to repeated keys (e.g., { status: ['sent', 'failed'] } → status=sent&status=failed).
 */
export function buildQueryString(params: Record<string, unknown>): string {
  const searchParams = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null) continue;
    if (Array.isArray(value)) {
      for (const item of value) {
        if (item !== undefined && item !== null) {
          searchParams.append(key, String(item));
        }
      }
    } else {
      searchParams.set(key, String(value));
    }
  }
  const query = searchParams.toString();
  return query ? `?${query}` : '';
}
